import {ApiClient} from '@hconnect/apiclient'
import {useCallback, useMemo, useState} from 'react'

import {StoppageDto} from '../../types'

export const useSubmit = (plantId: string, onSuccess?: () => void) => {
  const [isLoading, setIsLoading] = useState(false)

  const submitStoppage = useCallback(
    async (eventId: string) => {
      setIsLoading(true)
      try {
        await ApiClient.axiosInstance.put<StoppageDto>(
          `/shifthandover/${plantId}/events/${eventId}/submitted`
        )
        onSuccess?.()
      } catch (error) {
        setIsLoading(false)
      }
    },
    [onSuccess, plantId]
  )

  return useMemo(
    () => ({
      isLoading,
      submitStoppage
    }),
    [isLoading, submitStoppage]
  )
}
